

import Vue from 'vue'
import App from './App'
import FastClick from 'fastclick'
import router from './router';
import EmptyView from './components/EmptyView';
import store from './store';

import VueRouter from 'vue-router'
import Vuex from 'vuex'
import {sync} from 'vuex-router-sync'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

Vue.use(AlertPlugin,ToastPlugin,ConfirmPlugin)
Vue.use(VueRouter)
Vue.use(Vuex)

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import Mui from 'vue-awesome-mui';
Vue.use(Mui);

import SignCanvas from 'sign-canvas';
Vue.use(SignCanvas);

const shouldUseTransition = !/transition=none/.test(location.href)
this.$vux = Vue.$vux
store.registerModule('vux', {
state: {
demoScrollTop: 0,
isLoading: false,
direction: shouldUseTransition ? 'forward' : ''
},
mutations: {
updateDemoPosition (state, payload) {
state.demoScrollTop = payload.top
},
updateLoadingStatus (state, payload) {
state.isLoading = payload.isLoading
},
updateDirection (state, payload) {
if (!shouldUseTransition) {
return
}
state.direction = payload.direction
}
},
actions: {
updateDemoPosition ({commit}, top) {
commit({type: 'updateDemoPosition', top: top})
}
}
})

FastClick.attach(document.body)
sync(store, router)
const history = window.sessionStorage
history.clear()
let historyCount = history.getItem('count') * 1 || 0
history.setItem('/', 0)
let isPush = false
let isTouchStart = false
let endTime = Date.now()
let methods = ['push', 'go', 'replace', 'forward', 'back']

document.addEventListener('touchend', () => {
isTouchStart = false
endTime = Date.now()
})
document.addEventListener('touchstart', () => {
isTouchStart = true
})
methods.forEach(key => {
let method = router[key].bind(router)
router[key] = function (...args) {
isPush = true
method.apply(null, args)
}
})

router.beforeEach(function (to, from, next) {
store.commit('updateLoadingStatus', {isLoading: true})
const toIndex = history.getItem(to.path)
const fromIndex = history.getItem(from.path)
let direction
if (toIndex) {
if (!fromIndex || parseInt(toIndex, 10) > parseInt(fromIndex, 10) || (toIndex === '0' && fromIndex === '0')) {
direction = 'forward'
} else {
direction = 'reverse'
}
} else {
++historyCount
history.setItem('count', historyCount)
to.path !== '/' && history.setItem(to.path, historyCount)
direction = 'forward'
}

if (toIndex && toIndex !== '0' && !isPush && (((Date.now() - endTime) < 377) || isTouchStart)) {
store.commit('updateDirection', {direction: ''})
} else {
store.commit('updateDirection', { direction: direction })
}
isTouchStart = false
if (/\/http/.test(to.path)) {
let url = to.path.split('http')[1]
window.location.href = `http${url}`
} else {
next()
}
})
let dev = window.navigator.userAgent.toLocaleLowerCase().match(/MicroMessenger/i);
if (dev && dev[0] === 'micromessenger') {
store.commit('CLIENT', 0);
} else {
store.commit('CLIENT', 1);
}
router.afterEach(function (to) {
isPush = false
window.scrollTo(0,0)
store.commit('updateLoadingStatus', {isLoading: false})
if (process.env.NODE_ENV === 'production') {
}
})

Vue.config.productionTip = false
Vue.component('empty-view', EmptyView);

/* eslint-disable no-new */
new Vue({
store,
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js